export default {"src":"https://search.prod.wiggot.com/_next/static/media/asterisk.681e2405.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};